import type { Static } from 'runtypes';
import { Literal, Record, String, Number } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const AiShorthandRequestedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_SHORTHAND_REQUESTED),
    nodeId: Number,
    originalText: String,
    version: Literal(1),
  })
);

const AiShorthandRequestedEventServerRuntype = AiShorthandRequestedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiShorthandRequestedBrowserEvent = Static<typeof AiShorthandRequestedEventBrowserRuntype>;
type AiShorthandRequestedServerEvent = Static<typeof AiShorthandRequestedEventServerRuntype>;

const isAiShorthandRequestedBrowserEvent = (
  obj: BaseEvent
): obj is AiShorthandRequestedBrowserEvent => {
  return obj.event === 'AI Shorthand Requested';
};

const isAiShorthandRequestedServerEvent = (
  obj: BaseEvent
): obj is AiShorthandRequestedServerEvent => {
  return obj.event === 'AI Shorthand Requested';
};

export {
  isAiShorthandRequestedBrowserEvent,
  isAiShorthandRequestedServerEvent,
  AiShorthandRequestedEventBrowserRuntype,
  AiShorthandRequestedEventServerRuntype,
  type AiShorthandRequestedBrowserEvent,
  type AiShorthandRequestedServerEvent,
};
